import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
import { letterParagraphs, painPoints, solutionPoints } from '../data/content';
export function SalesLetter() {
  return <section className="w-full border-y border-ink-800 bg-ink-900 py-20" aria-labelledby="carta" style={{
    paddingTop: "20px",
    paddingBottom: "20px"
  }} data-id="element-154" data-mp="3uw3vghfeiyym">
      <div className="mx-auto w-full max-w-5xl px-4 sm:px-6" data-id="element-155" data-mp="3lunlgasi0yux">
        <h2 id="carta" className="max-w-4xl font-display text-3xl font-900 leading-tight text-white sm:text-[2.6rem]" style={{
        fontSize: "20px",
        fontWeight: "700"
      }} data-id="element-156" data-mp="meh56ef5un5c">
          ¿Sabías que el 73% de las instalaciones solares 
tienen al menos UN error crítico?


Desde cables mal conectados (riesgo de incendio) 
hasta paneles colocados en ángulo incorrecto 
(pérdida de 30% de producción).


La mayoría de dueños nunca se enteran 
hasta que ven su factura de luz 
o, peor aún, hasta que algo falla.


        </h2>

        <div className="mt-12 grid gap-12 lg:grid-cols-[1.05fr_0.95fr] lg:items-start" data-id="element-157" data-mp="119nfhdlah84h">
          <div className="space-y-10" data-id="element-158" data-mp="2n2zr6aoi0sma">
            <div className="space-y-4" data-id="element-159" data-mp="2n4146kp2rp6n">
              {letterParagraphs.map(paragraph => <p key={paragraph} className="text-[17px] leading-relaxed text-slate-300" data-id="element-160" data-mp="2rzzxmmp9fxdx">
                  {paragraph}
                </p>)}
            </div>

            <div className="border-l-2 border-gold pl-5" data-id="element-161" data-mp="2ia6mfmt15ka7">
              <p className="font-display text-xl font-700 leading-snug text-white sm:text-2xl" data-id="element-162" data-mp="2i8lrhw2szzbt">
                Presentamos: 
EL CÓDIGO SOLAR 360°
              </p>
              <p className="mt-3 text-[15px] leading-relaxed text-slate-300" data-id="element-163" data-mp="29b31see7swtl">
                El Código Solar 360° es el MANUAL DE DECISIÓN Y AUDITORÍA 
que todo dueño de casa debería tener ANTES de gastar 
un solo peso en energía solar.
No es un curso técnico aburrido.
No necesitas ser ingeniero para entenderlo.
No necesitas certificación.
Es tu escudo de protección.
Es tu lista de verificación.
Es tu brújula para tomar decisiones inteligentes.
              </p>
              
              <p className="mt-5 font-display text-sm font-700 uppercase tracking-[0.18em] text-gold" data-id="element-164" data-mp="16iqt4reae7ya">
                Sin ser técnico · Sin depender de nadie · Con total seguridad
              </p>
            </div>
          </div>

          
        </div>

      </div>
    </section>;
}